import React from 'react';
import { Award, ExternalLink } from 'lucide-react';

export const CertificationCard = ({ name, issuer, date, id, logo, verifyUrl }) => (
    <div className="bg-[#141414] p-4 rounded-lg border border-[#732424]/20 hover:border-[#d92323] transition-all duration-300 flex items-start gap-3 group">
        <div className="mt-1 w-8 h-8 rounded-md flex items-center justify-center flex-shrink-0 group-hover:scale-110 transition-transform duration-300 overflow-hidden">
            <img
                src={logo}
                alt={`${issuer} logo`}
                className="w-full h-full object-contain"
                onError={(e) => {
                    e.target.style.display = 'none';
                    e.target.nextSibling.style.display = 'flex';
                }}
            />
            <div className="w-full h-full bg-gradient-to-br from-[#d92323] to-[#b91c1c] flex items-center justify-center hidden">
                <Award className="w-4 h-4 text-white" />
            </div>
        </div>
        <div className="flex-1">
            <h4 className="text-white font-semibold text-sm leading-tight group-hover:text-[#d92323] transition-colors">{name}</h4>
            <div className="flex items-center gap-2 mt-2 text-xs text-[#7b7b7b]">
                <span className="text-white/60">{issuer}</span>
                <span>•</span>
                <span>{date}</span>
            </div>
            <div className="flex items-center justify-between mt-2">
                {id && <div className="text-[10px] text-[#7b7b7b] font-mono truncate max-w-[200px]">ID: {id}</div>}
                {verifyUrl && (
                    <a
                        href={verifyUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="flex items-center gap-1 text-[#d92323] hover:text-[#ff4444] transition-colors text-xs font-medium group/link"
                    >
                        <span>Verify</span>
                        <ExternalLink className="w-3 h-3 group-hover/link:translate-x-0.5 group-hover/link:-translate-y-0.5 transition-transform" />
                    </a>
                )}
            </div>
        </div>
    </div>
);